import { Link } from 'react-router-dom';

export function Home() {
  return (
    <>
      <section className="hero section">
        <div className="container hero-grid">
          <div className="hero-copy reveal">
            <p className="eyebrow">Expanding the financial frontier</p>
            <h1>Payment solutions for banks, fintechs, and problem solvers.</h1>
            <p className="lead">
              We combine platform infrastructure, domain expertise, and trusted partnerships to help you
              deliver modern financial experiences in a complex payments landscape.
            </p>
            <div className="cta-row">
              <Link className="btn btn-primary" to="/contact">
                Let's Talk
              </Link>
            </div>
          </div>
          <div className="hero-art reveal reveal-delay-1">
            <article className="hero-art-card metric-card">
              <img src="/img/cloud.svg" alt="" aria-hidden="true" />
              <div>
                <p className="metric-value">15+ years</p>
                <p>Cloud-native, API-first building blocks for modern fintech programs.</p>
              </div>
            </article>
            <article className="hero-art-card metric-card">
              <img src="/img/mobile.svg" alt="" aria-hidden="true" />
              <div>
                <p className="metric-value">24/7 support</p>
                <p>Seamless embedded experiences across apps, cards, and digital channels.</p>
              </div>
            </article>
            <article className="hero-panel">
              <h4>One platform, tailored experiences.</h4>
              <p>Launch faster with modular services spanning issuing, payments, risk, compliance, customer service, and program operations.</p>
              <div className="hero-chip-row">
                <span className="hero-chip">Card issuing</span>
                <span className="hero-chip">Payments</span>
                <span className="hero-chip">Risk</span>
                <span className="hero-chip">Compliance</span>
                <span className="hero-chip">Customer Service</span>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="section trust section-alt">
        <div className="container">
          <div className="trust-shell reveal">
            <p className="trust-label">Trusted by innovators in modern finance</p>
            <div className="logo-row">
              <img src="/img/galileo.svg" alt="Galileo" />
              <img src="/img/astra.svg" alt="Astra" />
              <img src="/img/transpecos.png" alt="TransPecos Banks" />
              <img src="/img/mastercard.svg" alt="Mastercard" />
              <img src="/img/aws.svg" alt="AWS" />
              <img src="/img/google-pay.svg" alt="Google Pay" />
              <img src="/img/apple-pay.svg" alt="Apple Pay" />
              <img src="/img/sightspan.png" alt="SightSpan" />
              <img src="/img/dataseers.png" alt="DataSeers" />
            </div>
          </div>
          <div className="stats-band reveal reveal-delay-1">
            <article className="stat-pill">
              <h3>15+</h3>
              <p>Years operating fintech programs</p>
            </article>
            <article className="stat-pill">
              <h3>99.9%</h3>
              <p>Platform availability target</p>
            </article>
            <article className="stat-pill">
              <h3>50+</h3>
              <p>Partner integrations and providers</p>
            </article>
            <article className="stat-pill">
              <h3>24/7</h3>
              <p>Operations and support coverage</p>
            </article>
          </div>
        </div>
      </section>

      <section className="section section-problem">
        <div className="container split split-feature reveal">
          <div className="reveal reveal-delay-1">
            <p className="eyebrow">Problem solved</p>
            <h2>One platform, modular services.</h2>
            <p>
              We provide clients and partners with a broad suite of modular services that can be bundled to
              improve experiences for both businesses and end customers.
            </p>
            <p>
              From core program architecture through go-live support, our team helps you design confidently and
              scale responsibly.
            </p>
          </div>
          <div className="rounded-media-shell reveal reveal-delay-2 fintech-anim-shell" aria-hidden="true">
            <div className="modular-anim">
              <span className="fin-node fin-source">Client</span>
              <span className="fin-node fin-core">ExpanseFT</span>
              <span className="fin-node fin-payments">Payments</span>
              <span className="fin-node fin-risk">Risk</span>
              <span className="fin-node fin-compliance">Compliance</span>
              <span className="fin-node fin-partners">Partners</span>

              <span className="fin-link fin-link-ingress" />
              <span className="fin-link fin-link-payments" />
              <span className="fin-link fin-link-risk" />
              <span className="fin-link fin-link-compliance" />
              <span className="fin-link fin-link-partners" />

              <span className="fin-packet fin-packet-ingress" />
              <span className="fin-packet fin-packet-payments" />
              <span className="fin-packet fin-packet-risk" />
              <span className="fin-packet fin-packet-compliance" />
              <span className="fin-packet fin-packet-partners" />
            </div>
          </div>
        </div>
      </section>

      <section className="section section-soft">
        <div className="container">
          <div className="section-head section-head-home reveal">
            <h2>Our Core Values</h2>
            <p>The principles that we have built our business and reputation on.</p>
          </div>
          <div className="card-grid">
            <article className="value-card value-card-featured">
              <img className="value-icon" src="/img/handshake.svg" alt="" aria-hidden="true" />
              <h3>Partnership</h3>
              <p>Strong mutual relationships are key to success. We leverage strategic partnerships to create solutions that last.</p>
            </article>
            <article className="value-card value-card-platform">
              <img className="value-icon" src="/img/cloud.svg" alt="" aria-hidden="true" />
              <h3>Platform</h3>
              <p>Our dynamic platform enables plug-and-play services while supporting customized consultative delivery.</p>
            </article>
            <article className="value-card value-card-product">
              <img className="value-icon" src="/img/mobile.svg" alt="" aria-hidden="true" />
              <h3>Product</h3>
              <p>Build payment and card products with a unified, compliant fintech stack.</p>
            </article>
            <article className="value-card value-card-performance">
              <img className="value-icon" src="/img/bargraph.svg" alt="" aria-hidden="true" />
              <h3>Performance</h3>
              <p>Scale quickly with infrastructure and expertise that reduces heavy up-front investment.</p>
            </article>
            <article className="value-card value-card-people">
              <img className="value-icon" src="/img/logo.svg" alt="" aria-hidden="true" />
              <h3>People</h3>
              <p>Our team is our greatest asset and the force behind long-term value for every partner we support.</p>
            </article>
          </div>
          <div className="trust-quote reveal reveal-delay-2">
            <p>
              "ExpanseFT gives partners a modern, reliable path to launch and scale financial products with confidence."
            </p>
            <span>Platform Leadership Team</span>
          </div>
        </div>
      </section>
    </>
  );
}


